// native
import { TitleCasePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

//addon
import { TranslateService } from '@ngx-translate/core';

// services
import { PatientsService } from '../../core/services/patients.service';
import { AuthService } from '../../core/services/auth.service';

// models
import { Patient, PatientButtonActions } from '../../models';

@Component({
    selector: 'app-view-patient',
    templateUrl: './view-patient.component.html',
    standalone: false
})
export class ViewPatientComponent implements OnInit {
  patient: Patient;

  newTestButtonAction: PatientButtonActions = {
    nameThin: 'test',
    nameBold: 'new',
    action: () => this.openNewTest()
  }

  previousTestsButtonAction: PatientButtonActions = {
    nameThin: 'tests',
    nameBold: 'previous',
    action: () => this.openExistingTests()
  }

  buttonActions: Array<PatientButtonActions> = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private patientsService: PatientsService, 
    private translateService: TranslateService,
    private authService: AuthService
  ) { }

  ngOnInit() {
    if (!this.authService.isClinicalTrialReadOnlyNoPii) {
      this.buttonActions.push(this.newTestButtonAction);
    } 
    this.buttonActions.push(this.previousTestsButtonAction);

    this.route.params.subscribe(params => {
      const id = params['id'];
      this.patientsService.getOne(id).subscribe((patient: Patient) => {
        this.patient = patient;
      }, err => {
        this.closeForm();
      });
    });
    this.translateService.get('test').subscribe(() => this.setTranslations());
  }

  private setTranslations() {
    const titleCasePipe = new TitleCasePipe();
    this.newTestButtonAction.nameThin = titleCasePipe.transform(this.translateService.instant('test'));
    this.newTestButtonAction.nameBold = titleCasePipe.transform(this.translateService.instant('new'));
    this.previousTestsButtonAction.nameThin = titleCasePipe.transform(this.translateService.instant('tests'));
    this.previousTestsButtonAction.nameBold = titleCasePipe.transform(this.translateService.instant('previous'));
  }

  closeForm() {
    this.router.navigate(['/patients']);
  }

  openExistingTests() {
    this.router.navigate(['/tests', this.patient.id]);
  }

  openNewTest() {
    this.router.navigate(['/tests/new', this.patient.id]);
  }
}